import * as CreateJuridicalPersonTypes from 'src/actions/juridical-person/create/Types';
import { CreateJuridicalPersonAction } from 'src/actions/juridical-person/create/CreateJuridicalPerson.actions';

export interface CreateJuridicalPersonState {
  loading: boolean;
  error: boolean;
  errorMessage: {};
}

const initialState: CreateJuridicalPersonState = {
  loading: false,
  error: false,
  errorMessage: {}
};

export function CreateJuridicalPersonReducer(state: CreateJuridicalPersonState = initialState,
                                             action: CreateJuridicalPersonAction): CreateJuridicalPersonState {
  switch (action.type) {
    case CreateJuridicalPersonTypes.CREATE_JURIDICAL_PERSON_ATTEMPT:
      return {...state, loading: true, error: false};
    case CreateJuridicalPersonTypes.CREATE_JURIDICAL_PERSON_SUCCESS:
      return {...state, loading: false, error: false};
    case CreateJuridicalPersonTypes.CREATE_JURIDICAL_PERSON_FAILURE:
      return {...state, loading: false, error: true, errorMessage: action.payload};
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/juridical-person/CreateJuridicalPersonReducer.ts